var _style, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCredChainIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "ELEMENTS",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "25px",
    height: "25px",
    className: "credchain",
    viewBox: "0 0 25 25",
    style: {
      enableBackground: "new 0 0 25 25"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#304580;}\n\t.st1{fill:#ACC1E4;}\n\t.st2{fill:#859CCE;}\n\t.st3{fill:#FFFFFF;}\n\t.credchain{transform: scale(0.9);}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M16.1,9.4h3.7c1.7,0,3.1,1.3,3.1,3.1s-1.3,3.1-3.1,3.1h-3.7v1.6h3.7c2.6,0,4.7-2.1,4.7-4.7s-2.1-4.7-4.7-4.7 h-3.7V9.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M9.2,8.2l5.3,3.1V5.7L9.2,2.6l-1.8,1l-6.9,4v9.7l6.9,4l1.8,1l5.3-3.1v-5.5l-5.3,3.1l-3.9-2.3v-4.2L9.2,8.2z  M9.2,18.4l3.8-2.3v2l-3.8,2.3l-1.1-0.6l-5.9-3.6V8.7l5.9-3.6l1.1-0.6L13,6.8v2L9.2,6.6L3.9,9.7v5.9L9.2,18.4z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_00000017516225159463038700000010346116709324213930_",
    className: "st1",
    points: "7.6,14.3 6.9,13.8 6.9,11.2  9.2,12.6 9.2,15.2 9.2,15.2 9.2,12.6 11.5,11.2 9.2,9.8 9.2,9.8 6.9,11.2 6.9,13.8 6.9,13.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_00000055680254418567247120000000229736307369477023_",
    className: "st2",
    points: "9.2,12.6 9.2,15.2 11.5,13.8  11.5,11.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_00000000205195114356728650000017899307241570533000_",
    className: "st3",
    points: "6.9,11.2 6.9,13.8 7.6,14.3  9.2,15.2 9.2,15.2 9.2,12.6  "
  }))), /*#__PURE__*/React.createElement("rect", {
    x: 13.8,
    y: 12,
    className: "st0",
    width: 7,
    height: 0.9
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCredChainIcon);
export default __webpack_public_path__ + "static/media/cred-chain-icon.1963e21f.svg";
export { ForwardRef as ReactComponent };